<template>
  <div class="bank-selection-item" v-on:click="onSelection(source.sourceName)">
    <img class="logo-image" :src="require(`@/assets/bank-logos/${source.logoFile}`)">
    <div class="arrow-wrapper">
      <img class="arrow-image" :src="require('@/assets/onboarding/icons/left-arrow.svg')">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankSelectionItem',
  props: {
    source: {
      type: Object,
      required: true,
    },
    onSelection: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .bank-selection-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @include responsive-padding;
    height: 90px;
    padding-top: 20px;
    padding-bottom: 20px;

    .logo-image {
      height: 40px;
    }

    .arrow-wrapper {
      height: 100%;
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .arrow-image {
        height: 16px;
      }
    }
  }
</style>
